import { useEffect, useState } from "react";
import { IMAGE_URL } from "../services/api";

const ProtectedImage = ({ path, alt, className,style }) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (path && token) {
      // Always replace `/media/` with `/protected-media/`
      let protectedPath = path;
      if (protectedPath.startsWith("/media/")) {
        protectedPath = protectedPath.replace("/media/", "/protected-media/");
      }

      console.log("Fetching protected image:", protectedPath);

      fetch(`${IMAGE_URL}${protectedPath}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch image");
          return res.blob();
        })
        .then((blob) => {
          setImageUrl(URL.createObjectURL(blob));
        })
        .catch((err) => {
          console.error("Image fetch error:", err);
          setImageUrl(null);
        });
    }
  }, [path]);

  if (!imageUrl) return null;

  return <img src={imageUrl} alt={alt || "protected"} className={className} style={style}/>;
};

export default ProtectedImage;
